import {Collection} from "../lib/event-interface";
import {JoinedRoomData} from "./sx-server";
import webAPI from "../api/web-api-2";

const UPDATE_FREQUENCY = 120 * 1000;

const event = new Collection("vx-roomlist");

let updateTimer : number = null;
let roomList : {[key : string] : JoinedRoomData} = {};

export function enableAutoUpdate(enabled : boolean)
{
	if (enabled) {
		doUpdate();
		updateTimer = setInterval(doUpdate, UPDATE_FREQUENCY);
	} else {
		clearInterval(updateTimer);
	}
}

export function doUpdate()
{
	webAPI.get("member/visitx/getRoomList", {}).then((r : any) =>
	{
		if ("success" in r && r.success) {
			for (let room of r.data) {
				roomList[room.roomid] = room;
			}
			this.event.trigger("roomListUpdated");
		} else {
			// Just ignore
		}
	}).catch(r => {
		// Also ignore
	});
}

export function getRooms() : JoinedRoomData[]
{
	const res = [];
	for (let id of Object.keys(roomList)) {
		res.push(roomList[id]);
	}
	return res;
}

export function getRoom(roomID : string) : JoinedRoomData
{
	return roomID in roomList
		? {...roomList[roomID]} as JoinedRoomData
		: null;
}

export function updateRoomData(room : JoinedRoomData)
{
	let current = room.roomid in roomList
		? roomList[room.roomid]
		: null;

	if (current) {
		for (let k of Object.keys(room)) {
			current[k] = room[k];
		}
	} else {
		roomList[room.roomid] = room;
	}

	this.event.trigger("roomUpdated", room.roomid);
}

const vxRoomList = {event, doUpdate, getRoom, getRooms, updateRoomData, enableAutoUpdate};
export default vxRoomList;
